module.exports = ({
    "CDMS103P001": "กรุณากรอกที่อยู่อีเมลปัจจุบันของคุณ",
    "CDMS103P002": "กรุณากรอกรหัสผู้ใช้งานของคุณ",
    "CDMS103P003": "กรุณากรอกรหัสผ่านใหม่ของคุณ",
    "CDMS103P004": "กรุณายืนยันรหัสผ่านใหม่ของคุณ",
    "CDMS101P002": "กรุณากรอกคำตอบเพื่อความปลอดภัยของคุณ",
    "CDMS103MSG001": "กรุณากรอกอีเมลปัจจุบันของคุณ",
    "CDMS103MSG002": "อีเมลที่ใส่ได้ถูกลงทะเบียนไว้แล้ว",
    "CDMS103MSG003": "กรุณากรอกชื่อผู้ใช้งาน",
    "CDMS103MSG004": "รหัสผ่านที่ตั้งไว้เหมือนกับรหัสผ่านเดิมที่เคยใช้งานมาก่อน",
    "CDMS103MSG005": "กรุณากรอกรหัสผ่านที่มีความยาวอย่างน้อย 8 ตัวอักษร ใช้อักษรภาษาอังกฤษ ตัวเลข และอักขระพิเศษ",
    "CDMS103MSG006": "รหัสผ่านไม่ตรงกัน",
    "CDMS103MSG007": "กรุณากรอกรหัสผ่านใหม่ของคุณ",
    "CDMS103MSG008": "กรุณายืนยันรหัสผ่านใหม่ของคุณ",
    "CDMS101MSG003": "กรุณาระบุคำตอบสำหรับคำถามความปลอดภัย",
    "CDMS103BTN001": "กลับ",
    "CDMS103LB001": "รหัสผู้ใช้งาน",
    "CDMS103LB002": "อีเมลปัจจุบัน",
    "CDMS103LB003": "ชื่อผู้ใช้งาน",
    "CDMS103LB004": "รหัสผ่านใหม่",
    "CDMS103LB005": "ยืนยันรหัสผ่านใหม่",
    "CDMS103LB006": "คำถามความปลอดภัย",
    "CDMS103LB007": "คำตอบความปลอดภัย",
    "CDMS103TT001": "ข้อมูลผู้ใช้งาน",
    "CDMS103TT002": "ข้อมูลเบื้องต้น",
    "CDMS103TT003": "อัปเดตรหัสผ่าน",
    "CDMS103TT004": "อัปเดตคำถามความปลอดภัย",
    "CDMS104TT001": "อัปเดตรหัสผ่าน",
    "CDMS104LB001": "รหัสผู้ใช้งาน",
    "CDMS104LB002": "อีเมล",
    "CDMS104LB003": "รหัสผ่านใหม่",
    "CDMS104LB004": "ยืนยันรหัสผ่านใหม่",
    "CDMS104LB005": "เลือกคําถามและคําตอบความปลอดภัย",
    "CDMS104LB006": "คำถามความปลอดภัย",
    "CDMS104LB007": "คำตอบความปลอดภัย"
});